import Entity from './entity'
export default class Companyinformation extends Entity<number>{
    
    name:string;
    province:string;
    city:string;
    county:string;   
    villages:string;

}